import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Container, Grid } from '../../../components/mui/Core/index'
import GenericNav from '../../../components/genericcomponents/navbars/GenericNav'
import ItemDetailsCard from '../components/ItemDetailsCard/item-details-card'
import ItemCodeSummaryTable from './components/ItemCodeSummaryTable/item-code-summary-table'
import useBrowserTabTitles from '../../../hooks/browserTabTitles/browser-tab-titles'
import PageTitle from '../../../components/PageTitle/page-title'
import Constants from '../../../constants/en.json'
import { sessionStorageKeyConstants } from '../../../constants/session-storage-key-constants'

function ItemCodeSummary() {
  const selectedInventoryItem = useSelector((state) => state.inventory.selectedInventoryItem)

  const selectedClient = JSON.parse(
    sessionStorage.getItem(sessionStorageKeyConstants.SELECTED_CLIENT),
  )
  const pageTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${Constants.itemCodeSummary.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber} ${Constants.itemCodeSummary.ITEM_CODE_SUMMARY}`
    : `${Constants.itemCodeSummary.NDC_ITEM_NUMBER} ${selectedInventoryItem?.itemNumber} ${Constants.itemCodeSummary.ITEM_CODE_SUMMARY}`
  const browserTabTitle = selectedClient?.clientShortName
    ? `${selectedClient?.clientShortName} - ${Constants.itemCodeSummary.ITEM_CODE_SUMMARY} - ${Constants.itemCodeSummary.NDC_ITEM_NUMBER} ${selectedInventoryItem.itemNumber}`
    : `${Constants.itemCodeSummary.ITEM_CODE_SUMMARY} - ${Constants.itemCodeSummary.NDC_ITEM_NUMBER} ${selectedInventoryItem.itemNumber}`
  useBrowserTabTitles(browserTabTitle)
  const bodyStyle = { py: 5 }
  const responsiveStyle = { flexGrow: 1 }

  return (
    <Box sx={responsiveStyle}>
      <GenericNav selected='Inventory' user='authenticated' />
      <Container maxWidth='xl'>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <PageTitle title={pageTitle} />
          </Grid>
          <Grid size={{ xs: 12 }} sx={bodyStyle}>
            <ItemDetailsCard />
            <ItemCodeSummaryTable />
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default ItemCodeSummary
